module.exports = __webpack_public_path__ + "media/images/Thomas02B-a6444ebf.png";